/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_All_KindsInputs */

const vi_stocktake_filter_all_kinds = /** @type {(inputs: Stocktake_Filter_All_KindsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả loại`)
};

/**

* @param {Stocktake_Filter_All_KindsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_all_kinds = /** @type {((inputs?: Stocktake_Filter_All_KindsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_All_KindsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_all_kinds(inputs)
});